import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import ability from '../../helpers/ability';

export const AbilityContext = createContext(ability);

export default createContextualCan(AbilityContext.Consumer);